import PwdForgotten from "./container";

export default PwdForgotten;
